async function DesignFolderSaveMaterials (designfoldermaterialhandledid, designfolderid, materialhandledid, modifiedbyid, deleted) {

    if (
        designfolderid.length > 0 && 
        materialhandledid.length > 0 && 
        modifiedbyid.length > 0 && 
        deleted.length > 0
    ) {

            let response;

            let params = {
                "@DesignFolderMaterialHandledId": designfoldermaterialhandledid,
                "@DesignFolderId": designfolderid,
                "@MaterialHandledId": materialhandledid,
                "@ModifiedById": modifiedbyid,
                "@Deleted": deleted

            };

            response = await fetch ("https://api.cssi.co/query", {
                method: "POST",
                body: JSON.stringify({
                    "sp": "65", 
                    "parameters": params,
                    "servername": "Compass-Svr3\\EXACTSQLEXPRESS", 
                    "databasename": "WebApps", 
                    "continuingfunction": null,
                    "noresults": false, 
                    "args": null
                })
            })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return Promise.resolve(response);
    }
}
 
export default DesignFolderSaveMaterials;